module.exports = __webpack_public_path__ + "static/media/icn-line.ba382101.svg";